import { useState } from "react";
import { useConsent } from "../../contexts/ConsentContext";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";
import ConsentToggle from "./ConsentToggle";
import "./PreferenceCentre.css";

const PreferenceCentre = ({ onClose }) => {
  // Mounted only while open (see CookieBanner.jsx's {showPrefs && ...}).
  useBodyScrollLock(true);
  const { functional, analytics, personalisation, marketing, acceptAll, rejectNonEssential, customise } = useConsent();
  const [draft, setDraft] = useState({ functional, analytics, personalisation, marketing });

  const set = (key) => (value) => setDraft((d) => ({ ...d, [key]: value }));

  const save = () => {
    customise(draft, "preference_centre");
    onClose();
  };

  const acceptAllAndClose = () => {
    acceptAll("preference_centre");
    onClose();
  };

  const rejectAllAndClose = () => {
    rejectNonEssential("preference_centre");
    onClose();
  };

  return (
    <div className="pref-centre-overlay" role="dialog" aria-modal="true" aria-label="Cookie and privacy preferences" data-lenis-prevent>
      <div className="pref-centre-modal" data-lenis-prevent>
        <button type="button" className="pref-centre-close" onClick={onClose} aria-label="Close">×</button>
        <h2>Cookie &amp; Privacy Preferences</h2>
        <p className="pref-centre-intro">
          Choose what we're allowed to use — you can change this any time via
          "Cookie Settings" in the footer. Turning everything off still lets
          you browse, search and place orders normally.
        </p>

        <div className="pref-centre-list">
          <ConsentToggle
            label="Strictly necessary"
            description="Required for things like your selections, checkout and account login. The site can't work without these, so they can't be switched off."
            checked
            disabled
            lockedLabel="Always on"
          />
          <ConsentToggle
            label="Functional"
            description="Remembers preferences such as your delivery station and recently used filters."
            checked={draft.functional}
            onChange={set("functional")}
          />
          <ConsentToggle
            label="Analytics & performance"
            description="Helps us understand how the site is used — page views, searches and where people drop off — so we can improve it."
            checked={draft.analytics}
            onChange={set("analytics")}
          />
          <ConsentToggle
            label="Personalisation"
            description="Lets us show recently viewed items, related products, and remember your selections between visits."
            checked={draft.personalisation}
            onChange={set("personalisation")}
          />
          <ConsentToggle
            label="Marketing"
            description="Used to measure and tailor promotions. We never sell your data to third parties."
            checked={draft.marketing}
            onChange={set("marketing")}
          />
        </div>

        <div className="pref-centre-actions">
          <button type="button" className="pref-btn pref-btn-reject" onClick={rejectAllAndClose}>
            Reject non-essential
          </button>
          <button type="button" className="pref-btn pref-btn-save" onClick={save}>
            Save preferences
          </button>
          <button type="button" className="pref-btn pref-btn-accept" onClick={acceptAllAndClose}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreferenceCentre;
